import React, { useState } from "react";
import WIIASCEND from "../assets/images/wii-blue.png";
import { formatPhone } from "../utils/mask-number";
import { countryOptions } from "../utils/country";

// const SCRIPT_URL =
//   "https://script.google.com/macros/s/AKfycbzdN6kba7P8TT9xoYX1M8XM8lcFP2uRlHldDzfnxfmM6YpO-CNXcHmbkLDONcJVmQRk/exec";

// const SCRIPT_URL_CONOSCO =
//   "https://script.google.com/macros/s/AKfycbx1rS9-Nl3O1O60lC0mXUf5TRx-WYJXFkcoPJGjj0aJgTl5fOy53xlpGZsgpI6ogl3s4w/exec";

const Contact = ({ isOpen, closeModal }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [country, setCountry] = useState(countryOptions[0]);
  const [status, setStatus] = useState("");

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const allDigits = value.replace(/\D/g, "");
      const localDigits = allDigits.startsWith(country.ddi)
        ? allDigits.slice(country.ddi.length)
        : allDigits;
      const formattedLocal = formatPhone(localDigits, country.value);
      const newValue = `${country.ddi} ${formattedLocal}`;
      setForm((prev) => ({ ...prev, phone: newValue }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCountryChange = (e) => {
    const sel = countryOptions.find((c) => c.value === e.target.value);
    if (!sel) return;
    setCountry(sel);
    setForm((prev) => ({ ...prev, phone: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Enviando...");
    try {
      const res = await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          number: form.phone,
          description: form.message,
        }),
      });

      if (res.ok) {
        setStatus("Enviado com sucesso!");
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus(`Erro na requisição: ${res.status} ${res.statusText}`);
      }
    } catch (err) {
      setStatus("Enviado com sucesso!");
      setForm({ name: "", email: "", phone: "", message: "" });
    }
  };

  const handleConoscoSubmit = async (e) => {
    e.preventDefault();
    setStatus("Enviando...");
    try {
      const res = await fetch(SCRIPT_URL_CONOSCO, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          number: form.phone,
          description: form.message,
        }),
      });

      if (res.ok) {
        setStatus("Enviado com sucesso!");
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus(`Erro na requisição: ${res.status} ${res.statusText}`);
      }
    } catch (err) {
      setStatus("Enviado com sucesso!");
      setForm({ name: "", email: "", phone: "", message: "" });
    }
  };

  return (
    <div className="fixed inset-0 bg-transparent flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-md p-8 rounded-xl shadow-lg">
        <div className="flex justify-between items-center">
          <div>
            <img
              src={WIIASCEND}
              alt="WIIASCEND"
              className="w-[150px] h-auto rounded-xl"
            />
          </div>
          <button onClick={closeModal} className="text-xl text-black bg-white">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-4 space-y-4" ref={formRef}>
          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-sm font-semibold text-[#081533]"
            >
              Nome completo
            </label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              type="text"
              id="name"
              placeholder="Digite aqui"
              required
              className="w-full text-black mt-2 px-4 py-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4 flex gap-4">
            <div className="w-full">
              <label
                htmlFor="email"
                className="block text-sm font-semibold text-[#081533]"
              >
                E-mail
              </label>
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                type="email"
                id="email"
                placeholder="email@exemplo.com"
                required
                className="w-full text-black mt-2 px-4 py-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div className="w-full mb-4">
            <label
              htmlFor="phone"
              className="block text-sm font-semibold text-[#081533]"
            >
              Telefone para contato
            </label>
            <div className="mt-2 flex gap-2">
              <select
                id="country"
                value={country.value}
                onChange={handleCountryChange}
                className="px-3 py-2 border border-gray-300 rounded-md text-black"
              >
                {countryOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label} (+{opt.ddi})
                  </option>
                ))}
              </select>

              <input
                name="phone"
                value={form.phone}
                onChange={handleChange}
                type="tel"
                id="phone"
                placeholder={`(${country.ddi}) 00000-0000`}
                className="flex-1 text-black px-4 py-2 border border-gray-300 rounded-md"
                required
              />
            </div>
          </div>
          <script>
            const phoneInputField = document.querySelector("#phone"); const
            phoneInput = window.intlTelInput(phoneInputField,{" "}
            {
              "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
            }
            );
          </script>

          <div className="mb-4">
            <label
              htmlFor="message"
              className="block text-sm font-semibold text-[#081533]"
            >
              Mensagem
            </label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              id="message"
              rows="4"
              placeholder="Digite aqui"
              required
              className="w-full mt-2 text-black px-4 py-2 border border-gray-300 rounded-md"
            />
          </div>

          <button
            type="submit"
            className="px-4 py-2 bg-[#887443] rounded-xs text-white hover:bg-[#887443]/90 transition-colors disabled:opacity-50"
          >
            Enviar
          </button>

          {status && (
            <p className="mt-2 text-center text-sm text-gray-700">{status}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
